export default __webpack_public_path__ + "static/media/FR.b892a817.svg";